export default (t) => {
    return [
        {
            header: t('Event'),
            accessor: 'event'
        },
        {
            header: t('Mutant'),
            accessor: 'mutant'
        },
        {
            header: t('Op'),
            accessor: 'op'
        },
        {
            header: t('Process'),
            accessor: 'proc'
        },
        {
            header: t('Status'),
            accessor: 'status',
            parser: (value) => '0x' + value.toString(16).toUpperCase().padStart(8, '0')
        },
    ];
};
